import { connect } from 'react-redux'
import SchoolFilesFilter from './school-files-filter'
import { getFilter } from '../../../../../stores/school-files/school-files.selectors'
import {
  resetFilters,
  setSearchFilters,
  fetchAgeGroups
} from '../../../../../stores/school-files/school-files.actions'

const mapStateToProps = state => {
  const filter = getFilter(state)
  return {
    title: filter.title,
    benchmarked: filter.benchmarked,
    judgement: filter.judgement,
    moderationType: filter.moderationType,
    owner: filter.owner,
    yearGroup: filter.yearGroup
  }
}

const mapDispatchToProps = dispatch => ({
  onFiltersUpdate: values => dispatch(setSearchFilters(values)),
  onClearFilters: () => dispatch(resetFilters()),
  onPullAgeGroups: () => dispatch(fetchAgeGroups())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SchoolFilesFilter)
